import React, { useState, useRef } from "react";
import CrossIcon from "assets/images/icons/cross-icon.svg";
import SaveIcon from "assets/images/icons/Save-icon.svg";
import {
  handleChange as tableHandleChange,
  handleDelete,
  handlEdit,
  handleSave,
} from "utils/TableFunctions";
import { CustomAmountInput, CustomForm } from "shared/AllInputs";
import CustomOverlay from "shared/CustomOverlay";
import DeleteModal from "shared/Modals/DeleteModal";
import EuroIcon from "assets/images/svg/euroIcon.svg";
import SizeM2 from "assets/images/svg/SizeM2.svg";
import formValidation from "utils/validations";

const AddHeatingCostTable = ({ customHeader, allValues, setAllValues }) => {
  const openAction = useRef(null);
  const ignoreInputs = ["status", "id"];
  const [deleteModal, setDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [idToDelete, setIdToDelete] = useState("");

  const onDelete = () => {
    handleDelete(allValues, setAllValues, idToDelete);
    setIdToDelete("");
    setDeleteModal(false);
  };

  const checkSizeError = (name, value, index, minValue) => {
    let values = [...allValues]
    let errors = values[index]?.formErrors || {}
    let sizeToError = formValidation(name, value, values, "", "", "", "size_from", "", minValue)
    let sizeFromError = formValidation("size_from", minValue, values)
    let formErrors = {
      ...errors,
      "size_to": sizeToError?.size_to,
      "size_from": sizeFromError?.size_from
    }
    let myObj = {
      ...values[index],
      size_from: minValue,
      formErrors: formErrors
    }
    values[index] = myObj
    setAllValues(values)
  }

  return (
    <>
      <CustomForm header={customHeader} col={12}>
        <div className="overflow-auto w-full">
          <table className="financial-table editor-container w-12 mt-3 table-error-align border-300 w-full border-round-lg">
            <thead>
              <tr>
                <th>Size From</th>
                <th>Size To</th>
                <th>Cost by sqm(Oil)</th>
                <th>Cost by sqm(Gas)</th>
                <th>Cost by sqm(Electricity)</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody id="" className="cell-width">
              {allValues?.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr>
                      <td
                        className={`pl-3 ${item.status === "save" ? "p-disabled" : ""
                          }`}
                      >
                        <CustomAmountInput
                          inputClass="m-0"
                          extraClassName="w-full p-0"
                          data={item}
                          col={12}
                          onChange={({ name, value }) => {
                            tableHandleChange(
                              name,
                              value,
                              index,
                              allValues,
                              setAllValues,
                              ignoreInputs,
                              [""],
                              item?.type,
                            )
                            checkSizeError("size_to", item?.size_to, index, value)
                          }}
                          name="size_from"
                          disabled={item?.status === "save" ? true : false}
                          spanIcon={SizeM2}
                          spanExtraClassName={"p-2"}
                          ignoreLabel
                        />
                      </td>
                      <td>
                        <CustomAmountInput
                          inputClass="m-0"
                          extraClassName="w-full p-0"
                          data={item}
                          col={12}
                          onChange={({ name, value }) => {
                            tableHandleChange(
                              name,
                              value,
                              index,
                              allValues,
                              setAllValues,
                              ignoreInputs,
                              [""],
                              item?.type,
                              "size_from",
                              "",
                              item?.size_from,
                            )
                          }}
                          name="size_to"
                          disabled={item?.status === "save" ? true : false}
                          spanIcon={SizeM2}
                          spanExtraClassName={"p-2"}
                          ignoreLabel
                        />
                      </td>
                      <td>
                        <CustomAmountInput
                          data={item}
                          inputClass="m-0"
                          onChange={({ name, value }) =>
                            tableHandleChange(
                              name,
                              value,
                              index,
                              allValues,
                              setAllValues,
                              ignoreInputs
                            )
                          }
                          name="cost_oil"
                          col={12}
                          disabled={item?.status === "save" ? true : false}
                          ignoreLabel
                          spanIcon={EuroIcon}
                        />
                      </td>
                      <td>
                        <CustomAmountInput
                          data={item}
                          inputClass="m-0"
                          onChange={({ name, value }) =>
                            tableHandleChange(
                              name,
                              value,
                              index,
                              allValues,
                              setAllValues,
                              ignoreInputs
                            )
                          }
                          name="cost_gas"
                          col={12}
                          disabled={item?.status === "save" ? true : false}
                          ignoreLabel
                          spanIcon={EuroIcon}
                        />
                      </td>
                      <td>
                        <CustomAmountInput
                          data={item}
                          inputClass="m-0"
                          onChange={({ name, value }) =>
                            tableHandleChange(
                              name,
                              value,
                              index,
                              allValues,
                              setAllValues,
                              ignoreInputs
                            )
                          }
                          name="cost_electricity"
                          col={12}
                          disabled={item?.status === "save" ? true : false}
                          ignoreLabel
                          spanIcon={EuroIcon}
                        />
                      </td>
                      {item?.status === "save" ? (
                        <td
                          style={{ minWidth: "20px" }}
                          className="vertical-align-middle"
                        >
                          <CustomOverlay ref={openAction}>
                            <ul className="no-style p-0">
                              <li
                                className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                                onClick={() =>
                                  handlEdit(allValues, setAllValues, index)
                                }
                              >
                                <i className="pi pi-file-edit text-dark"></i>
                                Edit
                              </li>
                              <li
                                className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                                onClick={() => {
                                  setIdToDelete(index);
                                  setDeleteModal(true);
                                }}
                              >
                                <i className="pi pi-trash cursor-pointer text-dark"></i>
                                Delete
                              </li>
                            </ul>
                          </CustomOverlay>
                        </td>
                      ) : (
                        <td
                          style={{ minWidth: "20px" }}
                          className="vertical-align-middle"
                        >
                          <div className="d-flex gap-3">
                            <a
                              className="cursor-pointer"
                              onClick={() =>
                                handleSave(
                                  index,
                                  allValues,
                                  setAllValues,
                                  ignoreInputs,
                                  [],
                                  "size_from"
                                )
                              }
                            >
                              <img src={SaveIcon} />
                            </a>
                            <a
                              className="cursor-pointer"
                              onClick={() => {
                                handleDelete(allValues, setAllValues, index);
                              }}
                            >
                              <img src={CrossIcon} />
                            </a>
                          </div>
                        </td>
                      )}
                    </tr>
                    <DeleteModal
                      isOpen={deleteModal}
                      setIsOpen={setDeleteModal}
                      onSubmit={onDelete}
                      loading={loading}
                      item={"link"}
                    />
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
        <br />
      </CustomForm>
    </>
  );
};

export default AddHeatingCostTable;
